/** All hardware fields present on a door — single source of truth for `HardwareFieldName`. */
export const HARDWARE_FIELD_NAMES = [
  'H1', 'H2', 'H3', 'H5', 'H6', 'H7', 'H8', 'H9',
  'H10', 'H11', 'H12', 'H13', 'H14', 'H15', 'H16', 'H17', 'H19',
  'H22', 'H23', 'H24', 'H25', 'H27', 'H28', 'H29',
  'H30', 'H31', 'H32', 'H33', 'H35',
  'H40', 'H41', 'H42', 'H43', 'H44', 'H45', 'H46', 'H47', 'H48', 'H49',
  'H60', 'H61', 'H62', 'H63', 'H64', 'H65', 'H66', 'H67', 'H68', 'H69',
  'H70', 'H71', 'H72', 'H73', 'H74'
] as const;

export type HardwareFieldName = (typeof HARDWARE_FIELD_NAMES)[number];

/** All trade fields present on a door — single source of truth for `TradeFieldName`. */
export const TRADE_FIELD_NAMES = [
  'T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8',
  'T9', 'T10', 'T11', 'T12', 'T13', 'T14', 'T15'
] as const;

export type TradeFieldName = (typeof TRADE_FIELD_NAMES)[number];

export interface DoorHardware {
  Qty: number;
  Content: string;
  Surf?: string;
  CompanyId?: string;
  Mounted: boolean;
  ChecklistId?: string;
}

export interface DoorCompanyTrade {
  CompanyId?: string;
  CompanyName?: string;
  Note?: string;
  Status?: string;
}

export interface DoorRoomType {
  Content?: string;
}

interface DoorBase {
  Id: string;
  ProjectId: string;
  DoorNo: string;
  DoorQty: number;
  Building?: string;
  Floor?: string;
  Revision?: string;
  LR?: string;
  RoomNo?: string;
  Comment?: string;
  Status?: string;
  RoomType?: DoorRoomType;
}

export type Door = DoorBase
  & Partial<Record<HardwareFieldName, DoorHardware | null>>
  & Partial<Record<TradeFieldName, DoorCompanyTrade | null>>;
